import productsMdl from "./products.mdl";
import productPageMdl from "./productPage.mdl";

export default [...productsMdl, ...productPageMdl];
